import { DisciplineActionsEnum } from "../types"

const { COUNSEL, VERBAL, WRITTEN_1, WRITTEN_FINAL, NOTICE_1, HEARING, TERMINATE } = DisciplineActionsEnum

export const defaultActionFlowConfig = [
  COUNSEL,
  VERBAL,
  WRITTEN_1,
  WRITTEN_FINAL,
  NOTICE_1,
  HEARING,
  TERMINATE,
] as DisciplineActionsEnum[]

export const defaultCatchAllFlow = [NOTICE_1, TERMINATE] as DisciplineActionsEnum[]

export const flowTypes = {
  actionFlow: "actionFlow",
  catchAllFlow: "catchAllFlow",
}
